import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import toast from 'react-hot-toast';

let today = new Date();
today.setDate(today.getDate() -1);
let past = new Date(today);
let previousDays = window.configs.previousDaysToCheckAcc;
past.setDate(today.getDate() -previousDays);
today = new Date(today).toISOString().split('T')[0];
past = new Date(past).toISOString().split('T')[0];
console.log('about to set dates');
console.log('today ' + today) 
console.log('past ' + past) 

export const accCheckerSlice = createSlice({
  name: 'accChecker',
  initialState: {
    accessionList: '',
    siteList: '',
    accessionNotInDocPanelList:'',
    accessionNotInAmbraList:'',
    accCheckerData: '', 
    accCheckerDataAmbra: '',
    startDate: past,
    endDate: today,
    Processing: false,
    ErrorMessage: '',
    displayRow:'',
    selectedSite:0,
    missingAccsFromBoth:'',
  },
  reducers: {
    updateAccessionList: (state, action)  => {

      console.log(action.payload);
      var workon = action.payload
      //change carriage returns to commas
      workon = workon.replace(/\n/g, ",");
      //remove two or more commas together down to one
      workon = workon.replaceAll(",,", ",");
      //replace white space
      workon = workon.replace(/\s/g, "");
      //line separate all comma separated data
      workon = workon.replaceAll(",", ",\n");
      state.accessionList = workon;
    },
    updateSelectedSite: (state, action)  => {
      state.selectedSite = action.payload;
      console.log('selected site is ' + state.selectedSite)
    },

    updateMissingAccsFromBoth: (state, action)  => {
      state.missingAccsFromBoth = action.payload;
    },
    
    updateSelectedDate: (state, action)  => {
      console.log('in updateselecteddate');
      let { newDate, whichDate }= action.payload;
      console.log('new date is next');
      console.log(newDate);
      console.log(typeof newDate);
      console.log('newdate is before saving ' + newDate)
      if (whichDate === 'start') {
        state.startDate = newDate;  
      }
      else if (whichDate === 'end') {
        state.endDate = newDate;
      }
      console.log('new date is ' + newDate + ' for ' + whichDate);
      console.log('start date is ' + state.startDate + 'end date is ' + state.endDate);
    },
    updatedocpanelSiteList: (state, action) => {
      state.siteList = action.payload;
    },
    "clearaccCheckerData": (state, action) => {
      console.log('in clearaccCheckerData');
      state.accCheckerData = action.payload;
    },
    "accChecker/updateSelectedDate": (state,action) => {
      console.log('in acchecker/updateselecteddate');
      updateSelectedDate(state,action);
    },
    "updateaccCheckerData": (state, action) => {
      console.log('in updateaccCheckerData');
      console.log(action.payload)
      console.log('status from docpanel next');
      state.Processing = false;
      let missingAccs = [];
      console.log('action status is next');
      console.log(action.payload[0].status)
      if (action.payload[0].status == 'failed') {
        toast('No Cases found in DocPanel')
        state.accCheckerData = [];
        //check ambra for all accession #'s
        missingAccs = state.accessionList;
        console.log('time to check ambra for  ' + missingAccs);
    }
    else
    {
      state.accCheckerData = action.payload;
    }
/*      else {
          let accessionReturned = state.accCheckerData.map((r,i) => r.AccNo);
          let accessionListTemp = state.accessionNotInDocPanelList.replace(/\n/g, "");
          let accessionAsArray = accessionListTemp.split(','); 
          let missingAccs = accessionAsArray.filter(x => !accessionReturned.includes(x));
          console.log('missing accs from slice')
          console.log(missingAccs)
        }
*/
    },
    "updateaccCheckerDataAmbra": (state, action) => {
      console.log('in updateaccCheckerDataAmbra and typeof is next');
      console.log(typeof action.payload)
      console.log(action.payload)
      state.accCheckerDataAmbra = action.payload;
      state.Processing = false;
      let workingAccessionList = Object.keys(action.payload)
      console.log('length is ' + workingAccessionList.length);
      console.log('workingAccessionList is next');
      console.log(JSON.stringify(workingAccessionList));
      //might want to check for missing accs not found in either somewhere here
    },
    
    "getData": (state, action) => {
     console.log(action.payload);
     state.accCheckerData  = action.payload;
    },
    "accChecker/updateProcessing": (state, action) => {
      console.log('in accChecker/updateProcessing');
      updateProcessing(state,action);  
    },
    "updateProcessing": (state, action) => {
      console.log('in updateProcessing');
      state.Processing = action.payload;
      state.LoginMessage = (action.payload === false) ? 'Login Failed' : '';
    },
    "showRow": (state, action) => {
      state.displayRow = action.payload;
    },
    "completeResendingsweep" : (state, action) => {
      console.log('in completresendingsweep');
      state.Processing = false;
      if (action.payload === '200') {
        state.ErrorMessage = 'Resend Successful';
        toast.success('Resend Successful');
      }
      else
      {
        state.ErrorMessage = 'Resend Failed';
        toast.error('Resend Failed');
      }

    },

  },
});

export const { 
  updateProcessing, 
  completeResendingsweep,
  updateaccCheckerData,
  updatedocpanelSiteList,
  clearaccCheckerData,
  getData,
  updateAccessionList, 
  updateaccCheckerDataAmbra,
  updateSelectedDate,
  Processing, 
  ErrorMessage,
  showRow,
  updateSelectedSite,
  missingAccsFromBoth,
  UpdateMissingAccsFromBoth
} = accCheckerSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const getDataAsync = (accessionList,jwt,requestType, selectedSite) => dispatch => {
  
    
  dispatch(updateProcessing(true));
  dispatch(getDataAPI({accessionList,jwt,requestType,selectedSite}))
};


export const getDataAsyncAmbra = (missingAccs,jwt,requestType, selectedSite) => dispatch => {
  
    
  dispatch(updateProcessing(true));
  dispatch(getAccessionsFromAmbra({missingAccs,jwt,requestType,selectedSite}))
};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectaccCheckerData = state => state.accChecker;

export const resendOrmAsync = (id) => dispatch => {
  dispatch(resendORM({id}));
}

export const resendORM = createAsyncThunk(
  'loginAPIcall', 
  async (Payload,thunkAPI ) => {
  try {
    const { jwt } = thunkAPI.getState().login
    thunkAPI.dispatch(updateProcessing(true));
    thunkAPI.dispatch(clearaccCheckerData([]));
    const id  = Payload.id;

    const options = {
      'mode' : 'cors',
      'method' : 'get',
      headers: { 
        "Authorization" : `Bearer ${jwt}`,  
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    };
  console.log(options);
  const url = `${window.configs.api_server}/resendORM?id=${id}`;

  console.log(url);

  let response = await fetch(url,options)
  response = await response
  console.log (JSON.stringify(response));
  console.log(`response from resending sweep is ${response.status}`);
  thunkAPI.dispatch(completeResendingsweep(response.status));
 
  } catch (error) {
    console.error(error);
  }
  return;
})


export const getAccessionsFromAmbra = createAsyncThunk(
  'accChecker', 
  async (Payload,thunkAPI) => {
  try {
    console.log('in get accessions from ambra');
    thunkAPI.dispatch(updateProcessing(true));
    //thunkAPI.dispatch(clearaccCheckerData([]));

    let { missingAccs, jwt, selectedSite } = Payload;
    console.log(Payload);
     

    var accessionListObj = {}
    //convert array to string
    missingAccs = missingAccs.toString();
    //remove carraige returns from string
    let accessionList = missingAccs.replace(/\n/g, "");
    var accessionAsArray = missingAccs.split(','); 
    accessionListObj.AccessionNumbers = accessionAsArray
    
    const options = {
      'mode' : 'cors',
      'method' : 'post',
      'body' : JSON.stringify(accessionListObj),
      headers: { 
        "Authorization" : `Bearer ${jwt}`,  
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    };

console.log(options);
  let url = ''
  
  url = `${window.configs.api_server}/list/accCheckerAmbra?selectedSite=${selectedSite}`;

  
  console.log(url);

  let response = await fetch(url,options)
  response = await response
  response = await response.json();
  thunkAPI.dispatch(updateaccCheckerDataAmbra(response));
  thunkAPI.dispatch(updateProcessing(false));

 
  } catch (error) {
    console.error(error);
  }

  return;
})
//end getAccessionsFromAmbra


export const getDataAPI = createAsyncThunk(
  'accChecker', 
  async (Payload,thunkAPI) => {
  try {

    thunkAPI.dispatch(updateProcessing(true));
    thunkAPI.dispatch(clearaccCheckerData([]));

    let { accessionList, jwt, selectedSite } = Payload;
    console.log(Payload);
     
    var accessionListObj = {}
    //remove carraige returns from string
    accessionList = accessionList.replace(/\n/g, "");
    var accessionAsArray = accessionList.split(','); 
    accessionListObj.AccessionNumbers = accessionAsArray
    
    const options = {
      'mode' : 'cors',
      'method' : 'post',
      'body' : JSON.stringify(accessionListObj),
      headers: { 
        "Authorization" : `Bearer ${jwt}`,  
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    };

console.log(options);
  let url = ''
  
  url = `${window.configs.api_server}/list/accChecker?selectedSite=${selectedSite}`;

  
  console.log(url);

  let response = await fetch(url,options)
  response = await response
  response = await response.json();
  thunkAPI.dispatch(updateaccCheckerData(response));
  thunkAPI.dispatch(updateProcessing(false));

 
  } catch (error) {
    console.error(error);
  }

  return;
})


export const getSiteList = createAsyncThunk(
  'getSiteList', 
  async (Payload,thunkAPI) => {
  try {
    console.log('trying to get site list');
    thunkAPI.dispatch(updateProcessing(true));
    console.log(Payload);
    let { jwt } = Payload;
    console.log('jwt next');
    console.log(jwt);
  const options = {
      'mode' : 'cors',
      'method' : 'get',
      headers: { 
        "Authorization" : `Bearer ${jwt}`,  
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    };

  let url = ''
  
  url = `${window.configs.api_server}/list/docpanelSiteList`;

  
  console.log(url);

  let response = await fetch(url,options)
  response = await response
  response = await response.json();
  console.log('response status');
  console.log(response.status);
  console.log(response.content);  
  thunkAPI.dispatch(updatedocpanelSiteList(response.content));
  thunkAPI.dispatch(updateProcessing(false));

 
  } catch (error) {
    console.log(error.status)
    console.error(error);
    console.log('error in get site list');
    
  }

  return;
})

export default accCheckerSlice.reducer;
